import { type ReactNode } from 'react';

import {
  Box,
  type ButtonBaseProps,
  Checkbox,
  Divider,
  Radio,
  Stack,
  type StackProps,
} from '@mui/material';

import { SelectableOptionItemStyled } from './selectable-option-item.styled';

type SelectableOptionItemProps = {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
  leftElement?: ReactNode;
  renderFooter?: ReactNode;
  control?: 'radio' | 'checkbox';
  hideControl?: boolean;
  stackProps?: StackProps;
  buttonProps?: ButtonBaseProps;
};

export const SelectableOptionItem = (props: SelectableOptionItemProps) => {
  const {
    selected,
    onClick,
    children,
    leftElement,
    renderFooter,
    control = 'radio',
    hideControl = false,
    stackProps,
    buttonProps,
  } = props;

  return (
    <SelectableOptionItemStyled
      selected={selected}
      onClick={onClick}
      disableRipple
      {...buttonProps}
    >
      <Stack direction="row" alignItems="center" gap={1.5} p={2} {...stackProps}>
        {leftElement}
        <Stack flex={1} minWidth={0}>
          {children}
        </Stack>
        {!hideControl &&
          (control === 'radio' ? (
            <Radio checked={selected} size="small" sx={{ p: 0 }} />
          ) : (
            <Checkbox checked={selected} size="small" sx={{ p: 0 }} />
          ))}
      </Stack>
      {renderFooter && (
        <>
          <Box pt={2}>
            <Divider />
          </Box>
          {renderFooter}
        </>
      )}
    </SelectableOptionItemStyled>
  );
};
